export default "__VITE_ASSET__DsmtSBmS__"